import dispatch from 'utils/dispatcher/';
import dispatchCurry from 'utils/dispatcher/curry';
import {UI} from '../constants/appConstants';

/**
 * @deprecated
 */
const actions = {
	triggerAction(type, data) {
		dispatch(UI.TRIGGER, {type, data});
	},

	/* Main Spinner */

	openSpinner: dispatchCurry(UI.SPINNER.OPEN),

	closeSpinner: dispatchCurry(UI.SPINNER.CLOSE),

	openInnerSpinner: dispatchCurry(UI.SPINNER.INNER.OPEN),

	closeInnerSpinner: dispatchCurry(UI.SPINNER.INNER.CLOSE),

	/* Search */

	clearSearch: dispatchCurry(UI.SEARCH.CLEAR),

	setSearchSpinner: dispatchCurry(UI.SPINNER.SEARCH.SET),

	/* Alert */

	setAddButton: dispatchCurry(UI.ADD_BUTTON.SET),
};

export default actions;
